import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVueIcons } from 'bootstrap-vue'
import router from './router'
import axios from "axios";
import Qs from "qs";
import store from "./store/store.js"
import VueToastify from "vue-toastify";
import JSONbig from "json-bigint";
import eventBus from "./assets/js/eventBus";

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)
Vue.use(VueToastify,{
  my: {
    position:"top-right"
  }});

axios.defaults.transformRequest = [function (data) {
  if (data.toString() == "[object FormData]") {
    return data;
  } else {
    return Qs.stringify(data)
  }
}];
axios.defaults.transformResponse=[(data) => {
  if (typeof data === 'string') {
    try {
      data = JSONbig.parse(data);
    } catch (e) { /* Ignore */ } // Added this Ignore as it's the same in the Axios
  }
  return data;
}];

// Vue.prototype.$baseURL = "https://chat.dnzq.peizi.hkcorp.vip/";  // for test
// Vue.prototype.$baseURL = "http://127.0.0.1:9080/";  // for test

Vue.prototype.$baseURL = "https://chat.dnzqapi.com/";   // for live

Vue.prototype.$baseStoragePath = Vue.prototype.$baseURL+"files/chat-space/";

const instance = axios.create({
  baseURL: Vue.prototype.$baseURL,//"https://chatapp.hk9999z.com/",
  timeout: 30000,
  withCredentials: true
});
Vue.prototype.$http = instance;

instance.interceptors.response.use(
  function (response) {
    if (response && response.status === 401) {
      eventBus.$emit("logout");
    } else if (response && response.status === 403) {
      eventBus.$emit("require-password-change");
    }
    return response;
  },
  function (error) {
    const status = error.response && error.response.status;
    const url = error.config && error.config.url ? error.config.url : "";
    if (status === 401 && url.indexOf("api/user/login") === -1) {
      eventBus.$emit("logout");
    } else if (status === 403 && url.indexOf("api/user/password") === -1) {
      eventBus.$emit("require-password-change");
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,store,
  beforeCreate() {
		this.$store.commit('initialiseStore');
	},
  render: h => h(App)
}).$mount('#app')